import HeroSection from './Assets/HeroSection.js'
import Introduction from './Assets/Introduction.js'
import Testimonial from './Assets/Testimonial.js'
import JoinUs from './Assets/JoinUs.js'
import Footer from './Assets/Footer.js'


function HomePage() {
  return (
    <>
      <HeroSection/>
      <Introduction/>
      <Testimonial/>
      <JoinUs/>
      <Footer/>
    </>
    )
}

export default HomePage